<template>
  <div class="double-card-page-container mdl-shadow--2dp"  >
    <div class="mdl-card fill">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{'admin.subscriptions.history.label.title' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill scrollbarAll">
        <data-table
          page="history"
          :data.sync="history"
          :selectable="table.selectable"
          :columns="table.columns"
          :sort="table.sort"
          :filter="table.filter">
          <div slot="empty">
            <div class="empty-message">
              {{ 'admin.subscriptions.history.label.nohistory' | label }}
            </div>
          </div>
        </data-table>
      </div>
      <div class="mdl-card__actions">
        <div class="mdl-button mdl-js-button mdl-button--raised"
          v-on:click="back()">{{ 'admin.subscriptions.history.button.back' | label}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var api = require('api')
  var momentTz = require('moment-timezone')
  var makeDate = require('vue').filter('makeDate')
  module.exports = {
    ready: function () {
      this.findHistory()
    },
    components: {
      dataTable: require('c/components/Table')
    },
    methods: {
      back: function () {
        this.$router.go('/admin/subscriptions')
      },
      findHistory: function () {
        var self = this
        api.User.findWithHistory({id: self.$route.params.id}).then(function (response) {
          self.history = []
          if (response.data) {
            response.data.forEach(item => {
              self.history.push({
                method: item.method,
                type: item.type,
                status: item.status,
                to: item.to,
                on: makeDate(item.on, momentTz.tz.guess(), 'DD MMM YYYY HH:mm'),
                messageModelId: item.messageModelId ? item.messageModelId.split('-')[0] : null,
                messageModelStatus: item.messageModelStatus
              })
            })
          }
        }, function (err) {
          if (err.status !== 404) {
            self.$dispatch('show-error', err.data)
          }
        })
      }
    },
    data: function () {
      return {
        table: {
          selectable: false,
          columns: ['method', 'type', 'status', 'to', 'on', 'messageModelId', 'messageModelStatus'],
          sort: [],
          filter: []
        },
        history: []
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// History.vue?6a478872